// import React, { useState, useEffect, useCallback } from 'react';
// import { useSelector } from 'react-redux';
// import {
//     Grid,
//     Button,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     Paper,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Typography,
//     TextField,
//     Box,
//     Card,
//     CardContent
// } from '@mui/material';
// import dayjs from 'dayjs';
// import CustomDateRangePicker from "../Components/DatePicker/CustomDateRangePicker";
// import configServ from '../services/config';
// import { toast } from "react-hot-toast";
// import CardHeadMenu from '../Components/Card/CardHeadMenu/CardHeadMenu';

// const PayOut = () => {
//     // Redux Global States
//     const { company_id } = useSelector((state) => state.GlobalVariables);

//     // Form & UI States
//     const [dateRange, setDateRange] = useState([
//         dayjs().startOf('month'), // Default: 01/07/2026 (based on current date)
//         dayjs()                  // Present Date
//     ]);
//     const [departmentList, setDepartmentList] = useState([]);
//     const [selectedDepartment, setSelectedDepartment] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [payoutList, setPayoutList] = useState([]);

//     // Fetch Departments for Dropdown
//     const fetchLookupData = useCallback(async () => {
//         if (!company_id) return;
//         try {
//             const departmentRes = await configServ.getAllDepartments(company_id);
//             setDepartmentList(departmentRes?.status === true ? departmentRes.data || [] : []);
//         } catch (error) {
//             toast.error("Failed to load departments");
//         }
//     }, [company_id]);

//     useEffect(() => {
//         fetchLookupData();
//     }, [fetchLookupData]);

//     // Handle Search / Form Submit -> Real API call
//     const handleFetchPayout = useCallback(async () => {
//         if (!selectedDepartment) {
//             toast.error("Please select a department");
//             return;
//         }

//         const payload = {
//             company_id: parseInt(company_id),
//             department_id: parseInt(selectedDepartment),
//             start_date: dateRange[0] ? dateRange[0].format('YYYY-MM-DD') : '',
//             end_date: dateRange[1] ? dateRange[1].format('YYYY-MM-DD') : ''
//         };

//         try {
//             setLoading(true);

//             // Real API call
//             const res = await configServ.getPayoutData(payload);

//             if (res?.status === 200) {
//                 const initializedData = (res.data || []).map(emp => ({
//                     ...emp,
//                     basic_salary: '',
//                     allowance: '',
//                     deduction: '',
//                     net_payable: ''
//                 }));
//                 setPayoutList(initializedData);
//                 toast.success(res.message || "Payout data generated successfully.");
//             } else {
//                 setPayoutList([]);
//                 toast.error(res?.message || "Failed to fetch payout data");
//             }
//         } catch (error) {
//             setPayoutList([]);
//             toast.error("Failed to fetch payout data");
//         } finally {
//             setLoading(false);
//         }
//     }, [company_id, selectedDepartment, dateRange]);

//     // Auto load new data jab department change ho (agar already selected hai)
//     useEffect(() => {
//         if (selectedDepartment) {
//             handleFetchPayout();
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [selectedDepartment]);

//     // Handle Dynamic Input Changes in Table Rows
//     const handleInputChange = (index, field, value) => {
//         const updatedList = [...payoutList];
//         updatedList[index][field] = value;

//         // Simple Auto-Calculation logic if values exist
//         const basic = parseFloat(updatedList[index]['basic_salary']) || 0;
//         const allowance = parseFloat(updatedList[index]['allowance']) || 0;
//         const deduction = parseFloat(updatedList[index]['deduction']) || 0;

//         updatedList[index]['net_payable'] = (basic + allowance) - deduction;

//         setPayoutList(updatedList);
//     };

//     // Bulk Submit Form Action
//     const handleSubmitPayout = () => {
//         console.log("Final Payout Payload:", payoutList);
//         toast.success("Payout process initiated successfully!");
//     };

//     return (
//         <Box sx={{ p: 3 }} width="100%">


//             <CardHeadMenu
//                 prefix={"Na"}
//                 suffix={"Na"}
//                 title={"Employee Payout Management"}
//                 showCreate={false}
//             />

//             {/* Filter Section */}
//             <Card variant="outlined" sx={{ mb: 4, borderRadius: 2, boxShadow: '0px 2px 8px rgba(0,0,0,0.05)' }}>
//                 <CardContent sx={{ p: 3 }}>
//                     <Grid container spacing={3} alignItems="center">
//                         <Grid item xs={12} sm={6} md={4}>
//                             <CustomDateRangePicker
//                                 value={dateRange}
//                                 onChange={setDateRange}
//                                 fullWidth
//                             />
//                         </Grid>

//                         <Grid item xs={12} sm={6} md={4}>
//                             <FormControl fullWidth size="small">
//                                 <InputLabel id="dept-select-label">Select Department</InputLabel>
//                                 <Select
//                                     labelId="dept-select-label"
//                                     value={selectedDepartment}
//                                     label="Select Department"
//                                     onChange={(e) => setSelectedDepartment(e.target.value)}
//                                 >
//                                     {departmentList.map((dept) => (
//                                         <MenuItem key={dept.id} value={dept.id}>
//                                             {dept.name || dept.department_name}
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//                         </Grid>

//                         <Grid item xs={12} sm={12} md={4}>
//                             <Button
//                                 variant="contained"
//                                 color="primary"
//                                 fullWidth
//                                 onClick={handleFetchPayout}
//                                 disabled={loading}
//                                 sx={{ height: '40px', fontWeight: 'bold' }}
//                             >
//                                 {loading ? 'Generating...' : 'Generate Payout Data'}
//                             </Button>
//                         </Grid>
//                     </Grid>
//                 </CardContent>
//             </Card>

//             {/* Payout Data Table Section */}
//             {payoutList.length > 0 && (
//                 <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
//                     <TableContainer sx={{ maxHeight: 440 }}>
//                         <Table stickyHeader size="small">
//                             <TableHead>
//                                 <TableRow sx={{ '& th': { backgroundColor: '#f8fafc', fontWeight: 'bold', color: '#475569' } }}>
//                                     <TableCell>S.no</TableCell>
//                                     <TableCell>Employee Name</TableCell>
//                                     <TableCell>Designation</TableCell>
//                                     <TableCell align="center">Total/Present/Absent</TableCell>
//                                     <TableCell sx={{ minWidth: 120 }}>Basic Salary</TableCell>
//                                     <TableCell sx={{ minWidth: 120 }}>Allowance</TableCell>
//                                     <TableCell sx={{ minWidth: 120 }}>Deductions</TableCell>
//                                     <TableCell align="right" sx={{ minWidth: 120 }}>Net Payable</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {payoutList.map((row, index) => (
//                                     <TableRow key={row.employee_id} hover>
//                                         <TableCell>{index + 1}</TableCell>
//                                         <TableCell>
//                                             <Typography variant="body2" sx={{ fontWeight: 500 }}>{row.employee_name}</Typography>
//                                             <Typography variant="caption" color="textSecondary">{row.email}</Typography>
//                                         </TableCell>
//                                         <TableCell>{row.designation}</TableCell>
//                                         <TableCell align="center">
//                                             {row.total_days} / <span style={{ color: 'green' }}>{row.present}</span> / <span style={{ color: 'red' }}>{row.absent}</span>
//                                         </TableCell>
//                                         {/* Dynamic Calculation Fields */}
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 type="number"
//                                                 placeholder="0.00"
//                                                 value={row.basic_salary}
//                                                 onChange={(e) => handleInputChange(index, 'basic_salary', e.target.value)}
//                                             />
//                                         </TableCell>
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 type="number"
//                                                 placeholder="0.00"
//                                                 value={row.allowance}
//                                                 onChange={(e) => handleInputChange(index, 'allowance', e.target.value)}
//                                             />
//                                         </TableCell>
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 type="number"
//                                                 placeholder="0.00"
//                                                 value={row.deduction}
//                                                 onChange={(e) => handleInputChange(index, 'deduction', e.target.value)}
//                                             />
//                                         </TableCell>
//                                         <TableCell align="right" sx={{ fontWeight: 'bold', color: '#0f172a' }}>
//                                             ₹ {row.net_payable || '0.00'}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>

//                     {/* Action Footer */}
//                     <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', backgroundColor: '#f8fafc' }}>
//                         <Button
//                             variant="contained"
//                             color="success"
//                             onClick={handleSubmitPayout}
//                             sx={{ fontWeight: 'bold', px: 4 }}
//                         >
//                             Submit Bulk Payout
//                         </Button>
//                     </Box>
//                 </Paper>
//             )}
//         </Box>
//     );
// };

// export default PayOut;





import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
    Grid,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    TextField,
    Box,
    Card,
    CardContent
} from '@mui/material';
import dayjs from 'dayjs';
import CustomDateRangePicker from "../Components/DatePicker/CustomDateRangePicker";
import configServ from '../services/config';
import { toast } from "react-hot-toast";
import CardHeadMenu from '../Components/Card/CardHeadMenu/CardHeadMenu';

const PayOut = () => {
    // Redux Global States
    const { company_id } = useSelector((state) => state.GlobalVariables);

    // Form & UI States
    const [dateRange, setDateRange] = useState([
        dayjs().startOf('month'), // Default: 01/07/2026 (based on current date)
        dayjs()                  // Present Date
    ]);
    const [departmentList, setDepartmentList] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [loading, setLoading] = useState(false);
    const [payoutList, setPayoutList] = useState([]);

    // Fetch Departments for Dropdown
    const fetchLookupData = useCallback(async () => {
        if (!company_id) return;
        try {
            const departmentRes = await configServ.getAllDepartments(company_id);
            setDepartmentList(departmentRes?.status === true ? departmentRes.data || [] : []);
        } catch (error) {
            toast.error("Failed to load departments");
        }
    }, [company_id]);

    useEffect(() => {
        fetchLookupData();
    }, [fetchLookupData]);

    // Handle Search / Form Submit -> Real API call
    const handleFetchPayout = useCallback(async () => {
        if (!selectedDepartment) {
            toast.error("Please select a department");
            return;
        }

        const payload = {
            company_id: parseInt(company_id),
            department_id: parseInt(selectedDepartment),
            start_date: dateRange[0] ? dateRange[0].format('YYYY-MM-DD') : '',
            end_date: dateRange[1] ? dateRange[1].format('YYYY-MM-DD') : ''
        };

        try {
            setLoading(true);

            // Real API call
            // NOTE: Backend now returns only ACTIVE status employees
            const res = await configServ.getPayoutData(payload);

            if (res?.status === 200) {
                const initializedData = (res.data || []).map(emp => ({
                    ...emp,
                    basic_salary: '',
                    allowance: '',
                    deduction: '',
                    net_payable: ''
                }));
                setPayoutList(initializedData);
                toast.success(res.message || "Payout data generated successfully.");
            } else {
                setPayoutList([]);
                toast.error(res?.message || "Failed to fetch payout data");
            }
        } catch (error) {
            setPayoutList([]);
            toast.error("Failed to fetch payout data");
        } finally {
            setLoading(false);
        }
    }, [company_id, selectedDepartment, dateRange]);

    // Auto load new data jab department change ho (agar already selected hai)
    useEffect(() => {
        if (selectedDepartment) {
            handleFetchPayout();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDepartment]);

    // Handle Dynamic Input Changes in Table Rows
    const handleInputChange = (index, field, value) => {
        const updatedList = [...payoutList];
        updatedList[index][field] = value;

        // Simple Auto-Calculation logic if values exist
        const basic = parseFloat(updatedList[index]['basic_salary']) || 0;
        const allowance = parseFloat(updatedList[index]['allowance']) || 0;
        const deduction = parseFloat(updatedList[index]['deduction']) || 0;

        updatedList[index]['net_payable'] = (basic + allowance) - deduction;

        setPayoutList(updatedList);
    };

    // Bulk Submit Form Action
    const handleSubmitPayout = () => {
        console.log("Final Payout Payload:", payoutList);
        toast.success("Payout process initiated successfully!");
    };

    return (
        <Box sx={{ p: 3 }} width="100%">


            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"Employee Payout Management"}
                showCreate={false}
            />

            {/* Filter Section */}
            <Card variant="outlined" sx={{ mb: 4, borderRadius: 2, boxShadow: '0px 2px 8px rgba(0,0,0,0.05)' }}>
                <CardContent sx={{ p: 3 }}>
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12} sm={6} md={4}>
                            <CustomDateRangePicker
                                value={dateRange}
                                onChange={setDateRange}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="dept-select-label">Select Department</InputLabel>
                                <Select
                                    labelId="dept-select-label"
                                    value={selectedDepartment}
                                    label="Select Department"
                                    onChange={(e) => setSelectedDepartment(e.target.value)}
                                >
                                    {departmentList.map((dept) => (
                                        <MenuItem key={dept.id} value={dept.id}>
                                            {dept.name || dept.department_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleFetchPayout}
                                disabled={loading}
                                sx={{ height: '40px', fontWeight: 'bold' }}
                            >
                                {loading ? 'Generating...' : 'Generate Payout Data'}
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* Payout Data Table Section */}
            {payoutList.length > 0 && (
                <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow sx={{ '& th': { backgroundColor: '#f8fafc', fontWeight: 'bold', color: '#475569' } }}>
                                    <TableCell>S.no</TableCell>
                                    <TableCell>Employee Name</TableCell>
                                    <TableCell>Designation</TableCell>
                                    <TableCell align="center">Total/Present/Absent</TableCell>
                                    <TableCell sx={{ minWidth: 120 }}>Basic Salary</TableCell>
                                    <TableCell sx={{ minWidth: 120 }}>Allowance</TableCell>
                                    <TableCell sx={{ minWidth: 120 }}>Deductions</TableCell>
                                    <TableCell align="right" sx={{ minWidth: 120 }}>Net Payable</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {payoutList.map((row, index) => (
                                    <TableRow key={row.employee_id} hover>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>{row.employee_name}</Typography>
                                            <Typography variant="caption" color="textSecondary">{row.email}</Typography>
                                        </TableCell>
                                        <TableCell>{row.designation}</TableCell>
                                        <TableCell align="center">
                                            {row.total_days} / <span style={{ color: 'green' }}>{row.present}</span> / <span style={{ color: 'red' }}>{row.absent}</span>
                                        </TableCell>
                                        {/* Dynamic Calculation Fields */}
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                type="number"
                                                placeholder="0.00"
                                                value={row.basic_salary}
                                                onChange={(e) => handleInputChange(index, 'basic_salary', e.target.value)}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                type="number"
                                                placeholder="0.00"
                                                value={row.allowance}
                                                onChange={(e) => handleInputChange(index, 'allowance', e.target.value)}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                type="number"
                                                placeholder="0.00"
                                                value={row.deduction}
                                                onChange={(e) => handleInputChange(index, 'deduction', e.target.value)}
                                            />
                                        </TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold', color: '#0f172a' }}>
                                            ₹ {row.net_payable || '0.00'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Action Footer */}
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', backgroundColor: '#f8fafc' }}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={handleSubmitPayout}
                            sx={{ fontWeight: 'bold', px: 4 }}
                        >
                            Submit Bulk Payout
                        </Button>
                    </Box>
                </Paper>
            )}
        </Box>
    );
};

export default PayOut;